export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_URL
  if (raw == null || raw === '') return ''
  const trimmed = String(raw).trim()
  if (trimmed === '/' || trimmed.toLowerCase() === 'same-origin') return ''

  const normalized = trimmed.replace(/\/+$/, '')

  // Dev + phone/WebView via adb reverse: absolute http://localhost:<apiPort> points at the
  // device, not the Mac. Prefer same-origin so Vite's proxy reaches the backend.
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    try {
      const api = new URL(normalized, window.location.origin)
      const pageHost = window.location.hostname
      const apiIsLoopback = api.hostname === 'localhost' || api.hostname === '127.0.0.1'
      const pageIsLoopback = pageHost === 'localhost' || pageHost === '127.0.0.1'
      if (apiIsLoopback && pageIsLoopback) {
        return ''
      }
    } catch {
      /* keep normalized */
    }
  }

  return normalized
}
